import angular from 'angular';

angular
  .module('cxSettings')
  .controller('AddInvoiceTemplateDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'dataCache',
    'flySvc',
    'companyId',
    'templateTypes',
    'close',
    addInvoiceTemplateDialogCtrl,
  ]);

function addInvoiceTemplateDialogCtrl(
  $element,
  $http,
  appUrls,
  dataCache,
  flySvc,
  companyId,
  templateTypes,
  close,
) {
  var vm = this;
  vm.companies = dataCache.getCompanies();
  vm.multipleCompanies = dataCache.getAllCompanies().length > 1;
  vm.templateTypes = templateTypes;
  vm.documentTemplate = {
    languageCode: null,
    templateType: null,
    name: '',
    file: null,
    companyId: companyId || (vm.multipleCompanies ? null : dataCache.getArray('defaultcompany').id),
  };
  vm.showValidation = false;

  vm.templateUploaded = function(file) {
    if (!file) return;
    vm.documentTemplate.file = file;
  };

  vm.save = function() {
    vm.saving = true;
    var data = new FormData();
    data.append('name', vm.documentTemplate.name);
    data.append('languageCode', vm.documentTemplate.languageCode);
    data.append('templateType', vm.documentTemplate.templateType);
    data.append('companyId', vm.documentTemplate.companyId);
    data.append('data', vm.documentTemplate.file.data);

    $http({
      method: 'post',
      url: appUrls.api + '/api/documentTemplate/template',
      headers: {
        'Content-Type': undefined,
      },
      data: data,
    })
      .then(function({ data }) {
        $element.modal('hide');
        close(data, 500);
      })
      .catch(function({ data }) {
        flySvc.error(data);
      })
      .finally(function() {
        vm.saving = false;
      });
  };

  vm.cancel = function() {
    close(null, 500);
  };

  vm.deleteAttachment = function() {
    if (!vm.documentTemplate.file) return;

    vm.documentTemplate.file = undefined;
  };

  vm.isAdvancedUpload = (function() {
    var div = document.createElement('div');
    return (
      ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
      'FormData' in window &&
      'FileReader' in window
    );
  })();
}
